import { ReactNode } from 'react';

import { ChallengeTimelineItemType } from 'features/challenge/ChallengeTimelineItem';
import { CHALLENGE_TYPES } from 'features/challenge/config';
import { DueDateTargetProgressType } from 'features/challenge/config/types';

import { GoalNonRepeatedChallengeCard } from './ChallengeCard/NonRepeated';
import { GoalRepeatedChallengeCard } from './ChallengeCard/Repeated';

type TGoalChallengeCard = {
  challenge: ChallengeTimelineItemType;
  children?: ReactNode;
};

export const GoalChallengeCard = ({
  challenge,
  children,
}: TGoalChallengeCard) => {
  return challengeCardConstructorMap[challenge.type](challenge, children);
};

const challengeCardConstructorMap = {
  [CHALLENGE_TYPES.REPEATING]: (
    challenge: ChallengeTimelineItemType,
    children: ReactNode
  ) => (
    <GoalRepeatedChallengeCard
      title={challenge.title}
      picture={challenge.picture}
      emoji={challenge.emoji}
      sprintIds={challenge.sprintIds}
    >
      {children}
    </GoalRepeatedChallengeCard>
  ),
  [CHALLENGE_TYPES.NON_REPEATING]: (
    challenge: ChallengeTimelineItemType,
    children: ReactNode
  ) => (
    <GoalNonRepeatedChallengeCard
      title={challenge.title}
      picture={challenge.picture}
      emoji={challenge.emoji}
      completedDate={challenge.completedDate}
      dueDate={(challenge.target as DueDateTargetProgressType).dueDate}
    >
      {children}
    </GoalNonRepeatedChallengeCard>
  ),
};
